<template>
  <div class="disclaimer">
    <validation-observer
      v-slot="{ invalid }"
      ref="observer"
    >
      <validation-provider
        class="disclaimer__checkbox"
        v-for="(field, key) in disclaimers"
        v-bind:key="'disclaimer_' + key"
        :rules="field.rules"
        :name="key"
        :vid="key"
        v-slot="{ validate }"
      >
        <vb-checkbox
          v-model="disclaimers[key].value"
          @change="validate_fields($event, validate, key)"
          :vb_options="{
            name: key,
            text: field.text,
            type: 'light'
          }"
        />
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import { get_config } from '@utilities/commons'
import * as Validation from '@resources/validation'

export default {
  name: "sidebar-disclaimers",

  props: {
    validate_on_mount: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      disclaimers: {
        guestPrivacy: Validation.terms_and_privacy,

        ...(get_config('guiSettings.disclaimerCheckout')) && {
          disclaimerCheckout: {
            ...Validation.disclaimer_checkout,
            text: get_config('guiSettings.disclaimerCheckout'),
          },
        },
      }
    }
  },

  mounted() {
    this.emit_results(false)

    if (this.validate_on_mount) {
      let timer = setInterval(() => {
        if (this.$refs.observer) {
          clearInterval(timer)
          this.$refs.observer.validate().then(res => {
            let payload = res ? this.get_payload() : false
            this.emit_results(payload)
          })
        }
      }, 500)
    }
  },

  watch: {
    disclaimers: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.$refs.observer.validate().then(res => {
            let payload = res ? this.get_payload() : false
            this.emit_results(payload)
          })
        })
      }
    }
  },

  methods: {
    async validate_fields(value, validate, name) {
      await validate(value).then(res => {
        if (!res.valid) {
          this.emit_results(false)
          return
        }

        let fields = this.$refs.observer.fields

        for (let index = 0; index < Object.keys(fields).length; index++) {
          const key = Object.keys(fields)[index]
          if (key === name) continue
          if (!fields[key].valid) {
            this.emit_results(false)
            return
          }
        }
        this.emit_results(this.get_payload())
      })
    },

    get_payload() {
      let fields = this.$refs.observer.fields,
          payload = {}
      for (let index = 0; index < Object.keys(fields).length; index++) {
        const key = Object.keys(fields)[index]
        payload = {
          ...payload,
          [key]: this.disclaimers[key].value
        }
      }
      return payload
    },

    emit_results(payload) {
      this.$emit('change', { name: 'disclaimers-update', payload: payload })
    },
  }
}
</script>

<style lang="scss" scoped>

  .disclaimer {

    &__checkbox {
      display: inline-block;
      margin-bottom: $grid-gutter-width / 2;

      &:last-child{
        margin-bottom: 0;
      }
    }
  }

</style>